// src/prototype/config/demoDates.ts
// ============================================================
// DEMO DATE ANCHOR
// All demo dates are computed as offsets from a single anchor so
// nothing narratively "current" ever renders in the past. Set
// DEMO_ANCHOR_DATE to a fixed Date for a reproducible demo;
// it defaults to today. (Wave 2 · P29 · D3)
// ============================================================

export interface DateOffset {
  days?: number;
  weeks?: number;
  months?: number;
}

export const DEMO_ANCHOR_DATE: Date = new Date();

function shift(offset: DateOffset): Date {
  const d = new Date(DEMO_ANCHOR_DATE);
  if (offset.months) d.setMonth(d.getMonth() + offset.months);
  if (offset.weeks) d.setDate(d.getDate() + offset.weeks * 7);
  if (offset.days) d.setDate(d.getDate() + offset.days);
  return d;
}

// "Aug 1, 2026"
export function demoDate(offset: DateOffset = {}): string {
  return shift(offset).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

// "Aug 2026"
export function demoMonthYear(offset: DateOffset = {}): string {
  return shift(offset).toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
}

// Whole-month span between two offsets, for duration labels ("6 months").
export function demoDurationMonths(startOffset: DateOffset, endOffset: DateOffset): number {
  const MS_PER_MONTH = 1000 * 60 * 60 * 24 * 30.44;
  return Math.max(
    1,
    Math.round((shift(endOffset).getTime() - shift(startOffset).getTime()) / MS_PER_MONTH),
  );
}
